import React, { useState } from "react";
import { motion } from "framer-motion";
import { contactEndpoints } from "../../services/api";
import toast from "react-hot-toast";
const {CONTACT} = contactEndpoints
export default function ContactUs() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    question: "",
  });

  const [errors, setErrors] = useState({});
  const [loading,setLoading] = useState(false);

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Validate Form
  const validateForm = () => {
    let newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First name is required.";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required.";
    if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Valid email is required.";
    if (!formData.mobileNumber.trim() || !/^\d{10}$/.test(formData.mobileNumber)) newErrors.mobileNumber = "Valid 10-digit mobile number required.";
    if (!formData.question.trim()) newErrors.question = "Please enter your question.";
    return newErrors;
  };

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setLoading(true)

      const response = await fetch(CONTACT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }); 
      setLoading(false)
    
      if(response.ok) {
        toast.success("Message Sent Successfully !")
        setFormData({
          firstName:"",
          lastName:"",
          email:"",
          mobileNumber:"",
          question:""
        })
      
      }else {
        toast.error("Failed to send")
      }
    }
  };

  return (
    <div className="bg-white py-16 px-6 md:px-16">
      {/* Section Title */}
      <motion.div
        className="text-center mb-12"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h2 className="text-4xl font-extrabold text-goldenYellow uppercase tracking-wide">
          Contact Us
        </h2>
        <p className="text-gray-400 mt-3 text-lg max-w-2xl mx-auto leading-relaxed">
          Have a question? We’re here to help. Fill out the form below, and our team will respond as soon as possible.
        </p>
        <div className="w-32 h-1 bg-[#C9A227] mx-auto mt-4 rounded-full"></div>
      </motion.div>

      {/* Contact Form */}
      <motion.form
        className="max-w-3xl mx-auto bg-[#16213D] shadow-xl rounded-xl p-10 border border-[#C9A227]"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        onSubmit={handleSubmit}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* First Name */}
          <div>
            <label className="block text-gray-300 font-medium">First Name</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className="w-full mt-2 p-3 border border-gray-600 rounded-lg bg-[#0F172A] text-white focus:outline-none focus:border-[#C9A227]"
            />
            {errors.firstName && <p className="text-red-400 text-sm mt-1">{errors.firstName}</p>}
          </div>

          {/* Last Name */}
          <div>
            <label className="block text-gray-300 font-medium">Last Name</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              className="w-full mt-2 p-3 border border-gray-600 rounded-lg bg-[#0F172A] text-white focus:outline-none focus:border-[#C9A227]"
            />
            {errors.lastName && <p className="text-red-400 text-sm mt-1">{errors.lastName}</p>}
          </div>
        </div>

        {/* Email */}
        <div className="mt-6">
          <label className="block text-gray-300 font-medium">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full mt-2 p-3 border border-gray-600 rounded-lg bg-[#0F172A] text-white focus:outline-none focus:border-[#C9A227]"
          />
          {errors.email && <p className="text-red-400 text-sm mt-1">{errors.email}</p>}
        </div>

        {/* Mobile Number */}
        <div className="mt-6">
          <label className="block text-gray-300 font-medium">Mobile Number</label>
          <input
            type="text"
            name="mobileNumber"
            value={formData.mobileNumber}
            onChange={handleChange}
            className="w-full mt-2 p-3 border border-gray-600 rounded-lg bg-[#0F172A] text-white focus:outline-none focus:border-[#C9A227]"
          />
          {errors.mobileNumber && <p className="text-red-400 text-sm mt-1">{errors.mobileNumber}</p>}
        </div>

        {/* Question */}
        <div className="mt-6">
          <label className="block text-gray-300 font-medium">Your Message</label>
          <textarea
            name="question"
            value={formData.question}
            onChange={handleChange}
            className="w-full mt-2 p-3 border border-gray-600 rounded-lg bg-[#0F172A] text-white focus:outline-none focus:border-[#C9A227] h-32 resize-none"
          />
          {errors.question && <p className="text-red-400 text-sm mt-1">{errors.question}</p>}
        </div>

        {/* Submit Button */}
        <motion.button
          type="submit"
          className={`mt-6 ${loading ? "cursor-not-allowed" : " cursor-pointer"} w-full bg-[#C9A227] text-[#0F172A] font-semibold py-3 rounded-lg hover:bg-[#B79527] transition-all duration-300`}
          whileHover={{ scale: 1.05 }}
        >
          {
            loading ? "Submitting..." : "Submit"
          }
        </motion.button>
      </motion.form>
    </div>
  );
}
